import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
//import { cover } from '../utils/styles';
import { Container } from '../../components/Layout';

import Video from '../../components/Media/Video';

const HeroContainer = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
/* const VideoContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`; */

const HeroVideo = ({ input }) => {
  //console.log(input.primary);
  const vid = input.primary.video;

  switch (input.primary.size) {
    case 'Full-Width (Background)':
      return (
        <HeroContainer>
          <Video
            height={vid.height}
            width={vid.width}
            url={vid.embed_url}
            id={vid.title}
            thumbnail={vid.thumbnail_url}
            //thumb_width={vid.thumbnail_width}
            //thumb_height={vid.thumbnail_height}
            //fluid={true}
          />
        </HeroContainer>
      );

    case 'Left':
    case 'Right':
    default:
      return (
        <HeroContainer>
          <Container restrict>
            <Video
              height={vid.height}
              width={vid.width}
              url={vid.embed_url}
              id={vid.title}
              thumbnail={vid.thumbnail_url}
              //thumb_width={vid.thumbnail_width}
              //thumb_height={vid.thumbnail_height}
              //fluid={false}
              //config={{youtube: {playerVars: { showinfo: 1 },},}}
            />
          </Container>
        </HeroContainer>
      );
  }
};

HeroVideo.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroVideo;

/* <span>
          <Chip
            label={props.alias}
            background={true}
            theme_light={props.theme_light}
            theme_dark={props.theme_dark}
          />
        </span> */
